import { createLookupHook } from "./createLookupHook";


export const useSubscriptionLookups = createLookupHook<unknown>(
  "subscriptions",
  "/lookups/subscriptions",
);
